import request from '@/utils/request'
import { API_PATHS } from '@/utils/api-config'

/**
 * 获取登录用户信息
 * @returns {Promise<Object>} 用户信息
 */
export function getLoginInfo() {
  return request({
    url: API_PATHS.USER.GET_LOGIN_INFO,
    method: 'get'
  })
} 